import treeTrendsUi from './tree-trends-ui'

export default {
    treeTrendsUi
}
